document.addEventListener('alpine:init', () => {
  Alpine.data('scrollShadow', ({ direction }) => ({   
    direction,
    childElement: null,

    get isX() {
      return this.direction === 'x';
    },

    get isY() {
      return this.direction === 'y';
    },

    init() {
      this.$nextTick(() => {
        this.childElement = this.$el.children[0];
        if (!this.childElement) return;
        
        this.updateShadow();
        
        // Attach scroll listener to the scrollable element
        this.childElement.addEventListener('scroll', this.updateShadow.bind(this));
      });

      // Observe content size changes
      const resizeObserver = new ResizeObserver(() => {
        this.updateShadow();
      });

      resizeObserver.observe(this.$el);

      // Listen to window resize
      window.addEventListener('resize', () => {
        requestAnimationFrame(() => {
          this.updateShadow();
        });
      });
    },

    updateShadow() {
      if (!this.childElement) return;
      
      const scrollTop = this.childElement.scrollTop;
      const scrollLeft = this.childElement.scrollLeft;
      const scrollHeight = this.childElement.scrollHeight;
      const scrollWidth = this.childElement.scrollWidth;
      const clientHeight = this.childElement.clientHeight;
      const clientWidth = this.childElement.clientWidth;

      const threshold = 1;

      if (this.isY) {
        const isAtTop = scrollTop <= threshold;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight - threshold;

        this.$el.classList.toggle('shadow-top', !isAtTop);
        this.$el.classList.toggle('shadow-bottom', !isAtBottom);
      }

      if (this.isX) {
        const isAtLeft = scrollLeft <= threshold;
        const isAtRight = scrollLeft + clientWidth >= scrollWidth - threshold;

        this.$el.classList.toggle('shadow-left', !isAtLeft);
        this.$el.classList.toggle('shadow-right', !isAtRight);
      }
    },
  }));
});